export default __webpack_public_path__ + "static/media/next.b84b4fe6.svg";